export interface PageParams {
  currentPage?: number
  pageSize?: number
}
type DataTypeCode = 1 | 2 | 3 // 1文章/2投诉/3集体
export const locationShowCodeEnum = {
  1: {
    1101: 'WEB_TEMPLATE_1_ARTICLE_1',
    1102: 'WEB_TEMPLATE_1_ARTICLE_2',
    1103: 'WEB_TEMPLATE_1_NEW_REPORT',
    1104: 'WEB_TEMPLATE_1_KNOWLEDGE_EXTEND',
  },
  2: {
    1201: 'WEB_TEMPLATE_2_TOP_RED',
    1202: 'WEB_TEMPLATE_2_TOP_BLACK',
    1203: 'WEB_TEMPLATE_2_COMPLAIN_1',
    1204: 'WEB_TEMPLATE_2_COMPLAIN_2',
  },
  3: {
    1301: 'WEB_TEMPLATE_3_ARTICLE',
  },
} as const

export const REDBLACKLABEL = {
  1202: {
    label: '红榜',
    color: 'red',
    key: 'redTop',
  },
  1201: {
    label: '黑榜',
    color: 'black',
    key: 'blackTop',
  },
}

/**
 * 客户端类型
 * WEB/2APP
 */
export type ClientTypeCode = 1 | 2
/**
 * 专题模板code
 *  1 | 2 | 3
 */
export type TemplateTypeCode = 1 | 2 | 3
/**
 * 专题类型
 * 1:新车; 2:推广; 3:测评; 4:315
 */
export type TopicTypeCode = 1 | 2 | 3 | 4
/**
 * WEB-模板数据位置码
 */
export type LocationShowCodeEnum<T extends TemplateTypeCode> = typeof locationShowCodeEnum[T]
export type LocationShowCodeValue<T extends TemplateTypeCode, U extends keyof LocationShowCodeEnum<T>> = LocationShowCodeEnum<T>[U]

// 专题BodyJson基础数据类型
export interface TopicBodyJsonBase { title: string }
export interface TopicBodyJsonDivTop { div_0: { topCoverImg: string } }
export type TopicTemplateBodyJson<T extends TemplateTypeCode> = {
  1: TopicTemplateBodyJson_One
  2: TopicTemplateBodyJson_Two
  3: TopicTemplateBodyJson_Three
}[T]
// 专题模板一
export interface TopicBodyJsonDivOne<T extends TemplateTypeCode> extends TopicBodyJsonBase { locationShowCode: keyof LocationShowCodeEnum<T> }
/**
 * 模板一BodyJson
 */
export interface TopicTemplateBodyJson_OneBase {
  type: 'TopicTemplateBodyJson_One'
  div_1: TopicBodyJsonDivOne<any>[]
}
export type TopicTemplateBodyJson_One = {
  [key in `div_${2 | 3 | 4}`]: TopicBodyJsonBase
} & TopicTemplateBodyJson_OneBase & TopicBodyJsonDivTop

/**
 * 模板二的BodyJson
 */
export interface TopicTemplateCarBrand {
  brandId: number
  vendorId: number
  img: string
  brandName: string

}
export interface TopicTemplateBodyJson_TwoBase {
  type: 'TopicTemplateBodyJson_Two'
  div_2: TopicBodyJsonDivOne<any>[]
  div_4: { children: TopicTemplateCarBrand[] } & TopicBodyJsonBase
}
export type TopicTemplateBodyJson_Two = {
  [key in `div_${1 | 3}`]: TopicBodyJsonBase
} & TopicTemplateBodyJson_TwoBase & TopicBodyJsonDivTop

/**
 * 模板三的BodyJson
 */
export interface TopicTemplateBodyJson_ThreeBase {
  type: 'TopicTemplateBodyJson_Three'
  div_1: TopicBodyJsonDivOne<3>
}
export type TopicTemplateBodyJson_Three = {
  [key in `div_${2 | 3}`]: TopicBodyJsonBase
} & TopicTemplateBodyJson_ThreeBase & TopicBodyJsonDivTop

export interface TopicCssJson {
  class_body_bg: {
    rgb: string
  }
  font_color: {
    rgb: string
    titleColor: string
    subtitleColor: string
    titleBarColor: string
  }
}
export interface TopicData extends Omit<TopicBaseResponse, 'bodyJson' | 'cssJson'> {
  bodyJson: any // Partial<TopicTemplateBodyJson[T]> // 不同的模板存在差异
  cssJson: Partial<TopicCssJson>
}
export interface TopicTemplateData<T extends TemplateTypeCode> extends Omit<TopicBaseResponse, 'bodyJson' | 'cssJson'> {
  bodyJson: Readonly<TopicTemplateBodyJson<T>> // 不同的模板存在差异
  cssJson: Readonly<TopicCssJson>
}

// 专题基本信息响应类型
export interface TopicBaseResponse {
  clientTypeCode: ClientTypeCode
  coverImg: string
  description: string // 描述(百度收录用的)
  keywords: string // 关键字(百度收录用的)
  templateTypeCode: TemplateTypeCode // 模板code
  title: string // 标题(百度收录用的)
  topicTypeCode: TopicTypeCode // 专题类型code
  id: string
  bodyJson: string
  cssJson: string

}
// 专题轮播图/文字链响应类型
export interface TopicSwiperResponse {
  bannerImgLs: TopicSwiperBanner[]
  linkTextLs: TopicSwiperLink[]
}
export interface TopicSwiperBanner {
  coverImgUrl: string | null
  id: string
  title: string
  dataTypeCode: DataTypeCode
  link?: string
}
export interface TopicSwiperLink extends Omit<TopicSwiperBanner, 'coverImgUrl'> { }

// 模板的基础数据请求参数
export interface TopicTemplateBaseParams {
  templateTypeCode: TemplateTypeCode
  topicId: string
}
// 模板的基础数据响应类型中的资讯类型
export interface TopicArticleBase {
  articleId: string
  coverImgUrl: string
  title: string
}
export interface OtherArticle {
  dataTypeCode: DataTypeCode
  id: number
  title: string
  topicId: number
  link?: string
}
// 模板的基础数据响应类型中的过往专题
export interface PastTopic {
  id: string
  title: string
  coverImg: string
  topicTypeCode: TopicTypeCode// 专题类型code,
  templateTypeCode: TemplateTypeCode
  clientTypeCode: ClientTypeCode
}
/**
 * 模板的基础数据响应类型
 * 所有的模板的基础数据（模板编号：基础数据数据类型)
 */
export type TopicTemplateBase<T extends TemplateTypeCode> = {
  // 模板一模板的基础数据类型
  1: {
    type?: 'TopicTemplateBaseOne'
    newReport: TopicArticleBase[]
    knowledgeExtend: TopicArticleBase[]
    pastTopics: PastTopic[]
  }
  // 模板二模板的基础数据类型
  2: {
    type?: 'TopicTemplateBaseTwo'
    redTop: ({ content: string } & TopicArticleBase)[]
    blackTop: ({ content: string } & TopicArticleBase)[]
    pastTopics: PastTopic[]
  }
  // 模板三模板的基础数据类型
  3: {
    type?: 'TopicTemplateBaseThree'
    pastTopics: PastTopic[]
    otherArticle: OtherArticle[]
  }
}[T]

// 模板的分页数据请求参数
export interface TopicTemplatePageParams<T extends TemplateTypeCode, U extends keyof LocationShowCodeEnum<T>> extends PageParams {
  locationShowCodeEnum: LocationShowCodeValue<T, U>
  templateTypeCode: TemplateTypeCode
  topicId: string
}
/**
 * 模板的分页数据响应类型
 * 所有的模板的分页数据（模板编号：基础数据数据类型
 */
export type TopicTemplatePage<T extends TemplateTypeCode> = {
  1: TopicTemplateNewsItem
  2: TopicTemplateComplaintItem
  3: TopicTemplateNewsItem
}[T]
// 模板一、三模板的分页数据类型
export interface TopicTemplateNewsItem {
  id: string // 文章id,
  createTime: string // 文章时间,
  title: string //
  coverImgUrl: string | null //
  content: string
  authorName: string // 作者,
  lookCount: number // 阅读量,
  commentCount: number // 评论量,
  goodCount: number // 点赞量
}
// 模板二模板的分页数据类型
export interface TopicTemplateComplaintItem {
  id: string // 投诉id,
  createTime: string // 投诉时间,
  title: string
  carDealerProvinceId: string // 经销商省,
  carDealerCityId: string // 经销商市,
  carVendorId: string // 车商id,
  carVendorName: string // 车商名,
  carSeriesId: string // 车系id
  carSeriesName: string // 车系名
  issueTypeCodeLs: TopicTemplateComplaintIssueItem[]
  issueLabels: string[]
  lookCount: number // 阅读量,
  commentCount: number // 评论量,
  goodCount: number // 点赞量
}
// 问题
export type TopicTemplateComplaintIssueItem = 1 | 2 | 3 | 4
